<template>
	<div style="border: 1px solid #ccc;">
		<Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            style="height: 450px; overflow-y: hidden;"
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
        />
	</div>
</template>

<script type="text/javascript">

import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default {
	data() {
		return {
			editorConfig: { 
                placeholder: '请输入内容...' ,
                MENU_CONF: {
                    uploadImage: {
                        fieldName: 'file',
                        server: '/gorc/admin/upload',
                        meta: {
                            
                        },
                        headers: {
                            Token: this.$store.state.token
                        },
                        customInsert(res, insertFn) {
                            insertFn(res.data.img_url)
                        }
                    }
                }
                
            },
            mode: 'default',
            editor: null,
            html: this.value,
            toolbarConfig: { },
		}
	},
    props: {
        value: String
    },
    watch: {
        value() {
            this.html = this.value
        },
        html() {
            this.$emit('updateValue', this.html)
            this.$emit('input', this.html)
        }
    },
	components: {
		Editor, 
        Toolbar
	},
	methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
	},
    mounted() {

    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
}
</script>